<template>
  <div class="relative" ref="rootRef">
    <button
      type="button"
      aria-label="Select model"
      class="inline-flex items-center gap-2 rounded-full border border-nera-border px-3 py-1.5 text-sm text-nera-text transition-colors hover:bg-nera-light-hover"
      @click="isOpen = !isOpen"
    >
      <span class="font-medium">{{ selected.label }}</span>
      <i class="fas fa-chevron-down text-[10px] text-nera-muted"></i>
    </button>

    <Transition
      enter-active-class="transition duration-150 ease-out"
      leave-active-class="transition duration-100 ease-in"
      enter-from-class="opacity-0 translate-y-1"
      leave-to-class="opacity-0 translate-y-1"
    >
      <div
        v-if="isOpen"
        class="absolute bottom-full left-0 z-20 mb-2 w-48 rounded-xl border border-nera-border bg-nera-container p-1 shadow-md"
      >
        <button
          v-for="option in options"
          :key="option.value"
          type="button"
          :class="[
            'flex w-full items-center gap-3 rounded-lg px-3 py-2 text-sm transition-colors hover:bg-nera-light-hover',
            option.value === selectedFoundation ? 'text-nera-accent' : 'text-nera-text'
          ]"
          @click="select(option.value)"
        >
          <span class="flex-1 text-left font-medium">{{ option.label }}</span>
          <i v-if="option.value === selectedFoundation" class="fas fa-check text-xs"></i>
        </button>
      </div>
    </Transition>
  </div>
</template>

<script setup>
import { computed, onBeforeUnmount, onMounted, ref } from 'vue'
import { storeToRefs } from 'pinia'
import { useConversationsStore } from '../stores/conversations'

const { selectedFoundation } = storeToRefs(useConversationsStore())

const options = [
  { value: 'gemini', label: 'Gemini' },
  { value: 'anthropic', label: 'Claude' },
  { value: 'openai', label: 'ChatGPT' }
]

const isOpen = ref(false)
const rootRef = ref(null)
const selected = computed(() => options.find(option => option.value === selectedFoundation.value) || options[0])

const select = (value) => {
  selectedFoundation.value = value
  isOpen.value = false
}

const handleClickOutside = (event) => {
  if (rootRef.value && !rootRef.value.contains(event.target)) isOpen.value = false
}

onMounted(() => document.addEventListener('click', handleClickOutside))
onBeforeUnmount(() => document.removeEventListener('click', handleClickOutside))
</script>
